import { postJson } from '@m/utils/postJson';

export interface ZoneAvailabilityRequest {
  arrivalDateTime: string;
  latitude: number;
  longitude: number;
  returnDateTime: string;
  zoneId: string;
}

export interface ZoneAvailabilityResponse {
  available: boolean;
  currency?: string;
  price?: number;
}

export async function checkZoneAvailability(
  request: ZoneAvailabilityRequest,
  signal?: AbortSignal,
): Promise<ZoneAvailabilityResponse> {
  return postJson<ZoneAvailabilityResponse>('/api/zone-availability', request, { signal });
}
